import * as React from "react";
import {InfoWindow, Marker} from "react-google-maps";
import {Option} from "ts-option";
import Event from "../../model/event/Event";
import AppointmentCalendarTooltipBody from "../appointment/calendar/AppointmentCalendarTooltipBody";
import {default as InternalLatLng} from "../../model/map/LatLng";
import LatLng = google.maps.LatLng;

interface IState {
	/**
	 * Info window visible
	 */
	infoWindowVisible: boolean
}

interface IComponentProps {
	/**
	 * Marker position
	 */
	position: LatLng | InternalLatLng
	/**
	 * Info window content
	 */
	infoText: Option<string>
	/**
	 * Event to display on tooltip.
	 */
	event: Option<Event>
	/**
	 * Marker opacity.
	 */
	opacity?: number;
	/**
	 * Marker icon.
	 */
	icon?: string | google.maps.Icon | google.maps.Symbol
	/**
	 * Marker z-index.
	 */
	zIndex?: number
}

export default class MarkerWithInfoWindow extends React.Component<IComponentProps, IState> {

	constructor(props: IComponentProps) {
		super(props);
		this.state = {infoWindowVisible: false}
	}

	render() {
		return (
			<Marker zIndex={100}
					position={this.props.position}
					icon={this.props.icon}
					onClick={() => this.setState({infoWindowVisible: true})}
					clickable={this.props.infoText.isDefined || this.props.event.isDefined}>
				{this.state.infoWindowVisible && this.props.infoText && this.renderTextTooltip()}
				{this.state.infoWindowVisible && this.props.event.isDefined && this.renderExtendedTooltip()}
			</Marker>
		)
	}

	renderTextTooltip() {
		return this.props.infoText.map(it => {
			return (
				<InfoWindow position={this.props.position}
							onCloseClick={() => this.setState({infoWindowVisible: false})}>
					<span className={"t-body"} style={{whiteSpace: "pre"}}>{it}</span>
				</InfoWindow>
			);
		}).orNull
	}

	renderExtendedTooltip() {
		return this.props.event.map(event => {
			return (
				<InfoWindow position={this.props.position}
							onCloseClick={() => this.setState({infoWindowVisible: false})}>
					<AppointmentCalendarTooltipBody event={event}/>
				</InfoWindow>
			)
		}).orNull
	}

}